const FULFILLMENT_PROPERTY = "_Fulfillment method";
const FULFILLMENT_VALUES = ["Pickup", "Delivery"];
const PICKUP_LOCATION_ATTRIBUTE = "Pickup location";
const PICKUP_LOCATION_ID_ATTRIBUTE = "Pickup location ID";
const DELIVERY_POSTAL_ATTRIBUTE = "Delivery postal code";
const DELIVERY_SERVICE_ATTRIBUTE = "Freight service";
const DELIVERY_RATE_ATTRIBUTE = "Freight rate";
const DELIVERY_CURRENCY_ATTRIBUTE = "Freight currency";
const DELIVERY_CHARGE_ATTRIBUTE = "Delivery shipping charge";
const CART_FULFILLMENT_STRINGS = (() => {
  const element = document.querySelector("[data-cart-fulfillment-strings]");

  try {
    return element ? JSON.parse(element.textContent) : {};
  } catch (_error) {
    return {};
  }
})();

function fulfillmentText(key, fallback = "") {
  return CART_FULFILLMENT_STRINGS[key] || fallback;
}

function setCartError(message) {
  const errorElement = document.getElementById("cart-errors");

  if (errorElement) {
    errorElement.textContent = message || "";

    if (message) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }
}

function getFulfillmentMethod(item) {
  return item.properties && item.properties[FULFILLMENT_PROPERTY];
}

function updateCheckoutAvailability(cart) {
  const checkoutButton = document.querySelector("[data-cart-checkout]");
  const help = document.querySelector("[data-fulfillment-checkout-help]");

  if (checkoutButton) {
    checkoutButton.disabled = cart.item_count === 0;
  }

  if (help) {
    help.hidden = true;
  }

  mountDeliveryQuestionnaire();
  updateDeliveryQuestionnaireVisibility();
  updateDeliveryRateVisibility();
  updatePickupLocationsVisibility();
}

function mountDeliveryQuestionnaire() {
  const panel = document.querySelector("[data-cart-fulfillment-panel]");
  const source = document.querySelector(
    "#cart-delivery-form-section > .js-contents"
  );
  const sourceForm = source?.querySelector("[data-heavy-delivery-form]");
  const mountedForm = panel?.querySelector("[data-heavy-delivery-form]");
  const ratePanel = panel?.querySelector("[data-delivery-rate-panel]");

  if (!panel || !source) {
    return;
  }

  if (source.querySelector("[data-no-heavy-delivery-form]")) {
    mountedForm?.remove();
    return;
  }

  if (sourceForm) {
    mountedForm?.remove();
    panel.insertBefore(sourceForm, ratePanel || null);
    window.initializeCartDeliveryForm?.(sourceForm);
    return;
  }

  if (mountedForm) {
    window.initializeCartDeliveryForm?.(mountedForm);
  }
}

function updateDeliveryRateVisibility() {
  const panel = document.querySelector("[data-delivery-rate-panel]");

  if (!panel) {
    return;
  }

  const selector = document.querySelector("[data-cart-selector]");
  const showPanel = selector?.dataset.currentValue === "Delivery";

  panel.hidden = !showPanel;
  panel.setAttribute("aria-hidden", String(!showPanel));
  panel.querySelectorAll("input, button").forEach((field) => {
    field.disabled = !showPanel;
  });
}

function invalidateDeliveryRate(message = "") {
  const panel = document.querySelector("[data-delivery-rate-panel]");
  const results = panel?.querySelector("[data-delivery-rate-results]");
  const status = panel?.querySelector("[data-delivery-rate-status]");
  const contact = panel?.querySelector("[data-delivery-contact]");

  if (!panel) {
    return;
  }

  if (panel.dataset.freeShippingQualified === "true") {
    return;
  }

  delete panel.dataset.rateValid;
  results?.replaceChildren();
  if (contact) {
    contact.hidden = true;
  }

  if (status) {
    status.textContent = message;
    status.classList.remove("is-error");
  }
}

function showDeliveryContact(panel) {
  const contact = panel.querySelector("[data-delivery-contact]");
  const body = contact?.querySelector("[data-delivery-contact-body]");
  const postalCode = panel
    .querySelector("#Cart-delivery-postal-code")
    ?.value.trim()
    .toUpperCase();

  if (!contact) {
    return;
  }

  const status = panel.querySelector("[data-delivery-rate-status]");
  status?.classList.add("is-error");

  if (body) {
    body.value = [
      "Delivery availability assistance requested from the cart.",
      `Postal code: ${postalCode || "Not provided"}`,
      `Cart: ${window.location.href.split("#")[0]}`,
    ].join("\n");
  }

  contact.hidden = false;
}

function formatContactMoney(cents, currency) {
  const amount = Number(cents);

  if (!Number.isFinite(amount)) {
    return "Not available";
  }

  try {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: currency || "CAD",
    }).format(amount / 100);
  } catch (_error) {
    return `${(amount / 100).toFixed(2)} ${currency || "CAD"}`;
  }
}

function getDeliveryQuestionnaireSummary() {
  return Array.from(
    document.querySelectorAll("[data-heavy-delivery-form] fieldset.checkout-question")
  )
    .map((question) => {
      const prompt = question
        .querySelector("legend.question, .question")
        ?.textContent.replace(/\s+/g, " ")
        .replace(/\s*\*\s*$/, "")
        .trim();
      const answers = Array.from(
        question.querySelectorAll("input, textarea, select")
      )
        .filter(
          (field) =>
            !field.disabled &&
            field.value.trim() &&
            (field.type !== "radio" && field.type !== "checkbox" || field.checked)
        )
        .map((field) => {
          if (field.type === "radio" || field.type === "checkbox") {
            return (
              question.querySelector(`label[for="${CSS.escape(field.id)}"]`)
                ?.textContent.trim() || field.value.trim()
            );
          }

          return field.value.trim();
        });

      return prompt && answers.length ? `${prompt}: ${answers.join(", ")}` : null;
    })
    .filter(Boolean);
}

function buildDeliveryContactBody(cart, postalCode) {
  const currency = cart?.currency || "CAD";
  const selector = document.querySelector("[data-cart-selector]");
  const questionnaire = getDeliveryQuestionnaireSummary();
  const lines = [
    "Delivery availability assistance requested from the cart.",
    "",
    "REQUEST DETAILS",
    `Submitted: ${new Date().toISOString()}`,
    `Storefront language: ${document.documentElement.lang || "Not provided"}`,
    `Selected fulfillment method: ${selector?.dataset.currentValue || "Delivery"}`,
    `Postal code: ${postalCode || "Not provided"}`,
    `Cart page: ${window.location.href.split("#")[0]}`,
  ];

  if (questionnaire.length) {
    lines.push("", "DELIVERY QUESTIONNAIRE", ...questionnaire);
  }

  const attributes = Object.entries(cart?.attributes || {}).filter(
    ([, value]) => value !== null && String(value).trim()
  );

  if (attributes.length) {
    lines.push(
      "",
      "CART ATTRIBUTES",
      ...attributes.map(([key, value]) => `${key}: ${value}`)
    );
  }

  lines.push("", `PRODUCTS (${cart?.item_count || 0} items)`);

  (cart?.items || []).forEach((item, index) => {
    const properties = Object.entries(item.properties || {}).filter(
      ([, value]) => value !== null && String(value).trim()
    );
    const itemUrl = item.url
      ? new URL(item.url, window.location.origin).href
      : "Not available";

    lines.push(
      "",
      `${index + 1}. ${item.product_title || item.title || "Product"}`,
      `Variant: ${item.variant_title || "Default"}`,
      `SKU: ${item.sku || "Not provided"}`,
      `Variant ID: ${item.variant_id || "Not provided"}`,
      `Quantity: ${item.quantity}`,
      `Unit price: ${formatContactMoney(item.final_price, currency)}`,
      `Line total: ${formatContactMoney(item.final_line_price, currency)}`,
      `Product URL: ${itemUrl}`
    );

    if (properties.length) {
      lines.push(
        "Selections / answers:",
        ...properties.map(
          ([key, value]) => `- ${key.replace(/^_/, "")}: ${value}`
        )
      );
    }
  });

  if (cart) {
    lines.push(
      "",
      "CART TOTALS",
      `Items subtotal: ${formatContactMoney(cart.items_subtotal_price, currency)}`,
      `Cart total: ${formatContactMoney(cart.total_price, currency)}`,
      `Currency: ${currency}`,
      `Cart token: ${cart.token || "Not provided"}`
    );
  }

  return lines.join("\n");
}

function updateDeliveryQuestionnaireVisibility() {
  const form = document.querySelector("[data-heavy-delivery-form]");

  if (!form) {
    return;
  }

  const selector = document.querySelector("[data-cart-selector]");
  const showForm = selector?.dataset.currentValue === "Delivery";

  form.hidden = !showForm;
  form.setAttribute("aria-hidden", String(!showForm));
  form.querySelectorAll("input, textarea, select").forEach((field) => {
    field.disabled = !showForm;
  });

  if (showForm) {
    window.initializeCartDeliveryForm?.(form);
  }
}

async function getCart() {
  const rootUrl = window.Shopify?.routes?.root || "/";
  const cartUrl = routes.cart_url || `${rootUrl}cart`;
  const response = await fetch(`${cartUrl}.js`, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(
      fulfillmentText("unableLoadCart", "Unable to load the cart. Please try again.")
    );
  }

  return response.json();
}

function getCartDiscountCodes(cart) {
  const entries = cart.discount_codes || cart.discountCodes || [];

  return entries
    .map((entry) => (typeof entry === "string" ? entry : entry.code))
    .filter(Boolean);
}

// Upgrade codes saved on cart lines by the product page purchase options
function getCartUpgradeCodes(cart) {
  return [
    ...new Set(
      (cart.items || [])
        .map((item) => String(item.properties?._upgrade_code || "").trim())
        .filter(Boolean)
    ),
  ];
}

function hasCode(codes, code) {
  return codes.some((entry) => entry.toUpperCase() === code.toUpperCase());
}

function isPickupDiscountCode(code) {
  const normalizedCode = String(code || "").trim().toUpperCase();
  return normalizedCode === "PICKUP" || normalizedCode.startsWith("PICKUP-");
}

async function applyPickupDiscount(cart, sections = []) {
  const endpoint = String(
    CART_FULFILLMENT_STRINGS.pickupDiscountEndpoint || ""
  ).trim();

  if (!endpoint) {
    return cart;
  }

  const codeResponse = await fetch(endpoint, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cartToken: cart.token,
      currency: cart.currency,
      lines: cart.items.map((item) => ({
        key: item.key,
        variantId: item.variant_id,
        quantity: item.quantity,
        fulfillmentMethod: getFulfillmentMethod(item),
        properties: item.properties || {},
        sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
      })),
    }),
  });
  const codeData = await codeResponse.json().catch(() => ({}));
  const pickupCode = String(codeData.code || "").trim();

  if (!codeResponse.ok || !pickupCode) {
    throw new Error(
      codeData.error ||
        fulfillmentText(
          "unableApplyPickupDiscount",
          "Unable to update the pickup discount code. Please try again."
        )
    );
  }

  // The pickup code already includes the upgrade amounts it lists, and Shopify
  // applies only one product discount per line, so drop those upgrade codes
  const includedCodes = Array.isArray(codeData.includedCodes)
    ? codeData.includedCodes.map(String)
    : [];
  const codes = getCartDiscountCodes(cart).filter(
    (code) => !isPickupDiscountCode(code) && !hasCode(includedCodes, code)
  );
  codes.push(pickupCode);

  const response = await fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      discount: codes.join(","),
      sections,
      sections_url: window.location.pathname,
    }),
  });
  const updatedCart = await response.json();

  if (!response.ok || updatedCart.errors) {
    throw new Error(
      fulfillmentText(
        "unableApplyPickupDiscount",
        "Unable to update the pickup discount code. Please try again."
      )
    );
  }

  const appliedCode = (updatedCart.discount_codes || []).find(
    (entry) => entry.code?.toLowerCase() === pickupCode.toLowerCase()
  );

  if (!appliedCode || appliedCode.applicable === false) {
    throw new Error(
      fulfillmentText(
        "pickupDiscountInvalid",
        "The pickup discount code is not valid for this cart."
      )
    );
  }

  return updatedCart;
}

async function removePickupDiscount(cart, sections = []) {
  const currentCodes = getCartDiscountCodes(cart);
  const remainingCodes = currentCodes.filter(
    (code) => !isPickupDiscountCode(code)
  );

  // Restore upgrade codes that a pickup code had folded in
  getCartUpgradeCodes(cart).forEach((code) => {
    if (!hasCode(remainingCodes, code)) {
      remainingCodes.push(code);
    }
  });

  const unchanged =
    remainingCodes.length === currentCodes.length &&
    remainingCodes.every((code) => hasCode(currentCodes, code));

  if (unchanged) {
    return cart;
  }

  const response = await fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      discount: remainingCodes.join(","),
      sections,
      sections_url: window.location.pathname,
    }),
  });
  const updatedCart = await response.json();

  if (!response.ok || updatedCart.errors) {
    throw new Error(
      fulfillmentText(
        "unableApplyPickupDiscount",
        "Unable to update the pickup discount code. Please try again."
      )
    );
  }

  return updatedCart;
}

function refreshCartSections(parsedState) {
  const cartItems = document.querySelector("cart-items");

  if (!cartItems || !parsedState.sections) {
    window.location.reload();
    return;
  }

  cartItems.getSectionsToRender().forEach((section) => {
    const sectionRoot = document.getElementById(section.id);
    const sectionHtml = parsedState.sections[section.section];

    if (!sectionRoot || !sectionHtml) {
      return;
    }

    const elementToReplace =
      sectionRoot.querySelector(section.selector) || sectionRoot;
    elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
      sectionHtml,
      section.selector
    );
  });

  cartItems.classList.toggle("is-empty", parsedState.item_count === 0);
  document
    .getElementById("main-cart-footer")
    ?.classList.toggle("is-empty", parsedState.item_count === 0);
}

async function getVariantPickupLocations(variantId) {
  const rootUrl = window.Shopify?.routes?.root || "/";
  const response = await fetch(
    `${rootUrl}variants/${variantId}/?section_id=pickup-availability`
  );

  if (!response.ok) {
    throw new Error(
      fulfillmentText("unableLoadPickup", "Unable to load pickup locations.")
    );
  }

  const documentFragment = new DOMParser().parseFromString(
    await response.text(),
    "text/html"
  );
  const locations = new Map();

  documentFragment
    .querySelectorAll(
      '.pickup-availability-list-item[data-available="true"][data-location-id]'
    )
    .forEach((item) => {
      const locationId = item.dataset.locationId;
      const name = item.querySelector(
        ".pickup-availability-list-item-title"
      )?.textContent;
      const time = item.querySelector(".pickup-availability-preview")?.textContent;
      const address = item.querySelector(".pickup-availability-address");

      locations.set(locationId, {
        id: locationId,
        name:
          name?.trim() ||
          fulfillmentText("pickupLocationFallback", "Pickup location"),
        time: time?.trim() || "",
        addressHtml: address?.innerHTML || "",
        addressText: address?.textContent.replace(/\s+/g, " ").trim() || "",
      });
    });

  return locations;
}

function pickupLocationLabel(location) {
  return [location.name, location.addressText].filter(Boolean).join(" — ");
}

async function savePickupLocation(location, sections = []) {
  const cart = await getCart();
  const attributes = {
    ...(cart.attributes || {}),
    [PICKUP_LOCATION_ATTRIBUTE]: location
      ? pickupLocationLabel(location)
      : "",
    [PICKUP_LOCATION_ID_ATTRIBUTE]: location?.id || "",
  };
  const response = await fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      attributes,
      sections,
      sections_url: window.location.pathname,
    }),
  });

  if (!response.ok) {
    throw new Error(
      fulfillmentText(
        "unableSavePickup",
        "Unable to save the pickup location. Please try again."
      )
    );
  }

  return response.json();
}

async function saveDeliveryEstimate(postalCode, rate, sections = []) {
  const cart = await getCart();
  const rateCents = rate ? getDeliveryRateCents(rate) : null;
  const attributes = {
    ...(cart.attributes || {}),
    [DELIVERY_POSTAL_ATTRIBUTE]: postalCode || "",
    [DELIVERY_SERVICE_ATTRIBUTE]: rate ? getDeliveryRateName(rate) : "",
    [DELIVERY_RATE_ATTRIBUTE]: rateCents === null ? "" : String(rateCents),
    [DELIVERY_CURRENCY_ATTRIBUTE]: rate?.currency || cart.currency || "",
    [DELIVERY_CHARGE_ATTRIBUTE]: rate ? "Free Shipping" : "",
  };
  const response = await fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      attributes,
      sections,
      sections_url: window.location.pathname,
    }),
  });

  if (!response.ok) {
    throw new Error(
      fulfillmentText(
        "unableSaveDelivery",
        "Unable to save the delivery estimate. Please try again."
      )
    );
  }

  return response.json();
}

function getDeliveryRateName(rate) {
  return (
    rate.service_name ||
    rate.serviceName ||
    rate.name ||
    fulfillmentText("freightServiceFallback", "Freight service")
  );
}

function getDeliveryRateCents(rate) {
  const cents = Number(rate.total_price ?? rate.totalPrice);

  if (Number.isFinite(cents)) {
    return Math.round(cents);
  }

  const amount = Number(rate.total ?? rate.price ?? rate.amount);
  return Number.isFinite(amount) ? Math.round(amount * 100) : null;
}

function renderDeliveryAvailability(panel) {
  const results = panel.querySelector("[data-delivery-rate-results]");

  if (!results) {
    return;
  }

  const notice = document.createElement("div");
  const icon = document.createElement("span");
  const message = document.createElement("strong");

  notice.className = "cart-delivery-available";
  notice.setAttribute("role", "status");
  icon.className = "cart-delivery-available-icon";
  icon.setAttribute("aria-hidden", "true");
  icon.textContent = "✓";
  message.textContent = fulfillmentText(
    "deliveryAvailable",
    "Delivery is available to your location."
  );
  notice.append(icon, message);
  results.replaceChildren(notice);
}

async function calculateDeliveryRates(panel) {
  const button = panel.querySelector("[data-calculate-delivery-rate]");
  const postalInput = panel.querySelector("#Cart-delivery-postal-code");
  const status = panel.querySelector("[data-delivery-rate-status]");
  const endpoint = panel.dataset.endpoint;
  const cartForm = document.getElementById("cart");
  const originalButtonText = button?.textContent.trim();

  if (!button || !postalInput || !status) {
    return;
  }

  const postalCode = postalInput.value.trim().toUpperCase();
  postalInput.value = postalCode;
  invalidateDeliveryRate();

  if (!postalCode || (cartForm && !cartForm.reportValidity())) {
    status.textContent = fulfillmentText(
      "completeQuestionsPostal",
      "Please complete the delivery questions and postal code."
    );
    return;
  }

  if (!endpoint) {
    status.textContent = fulfillmentText(
      "rateNotConfigured",
      "Delivery rate service is not configured."
    );
    return;
  }

  panel.setAttribute("aria-busy", "true");
  panel.querySelectorAll("input, button").forEach((field) => {
    field.disabled = true;
  });
  button.textContent = fulfillmentText("checking", "Checking...");
  status.textContent = fulfillmentText(
    "checkingRate",
    "Checking delivery availability..."
  );

  try {
    if (window.syncCartFormAnswersToLineProperties) {
      await window.syncCartFormAnswersToLineProperties();
    }

    const cart = await getCart();
    const response = await fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cartToken: cart.token,
        currency: cart.currency,
        locale: document.documentElement.lang || "en",
        destination: { postalCode },
        lines: cart.items.map((item) => ({
          key: item.key,
          variantId: item.variant_id,
          quantity: item.quantity,
          fulfillmentMethod: getFulfillmentMethod(item),
          properties: item.properties || {},
          sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
        })),
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    const rates = responseData.rates || responseData.services || [];

    if (!response.ok || !rates.length) {
      throw new Error(
        responseData.error ||
          responseData.message ||
          fulfillmentText("contactUs", "Please contact us for delivery assistance.")
      );
    }

    const sortedRates = rates
      .slice()
      .sort(
        (first, second) =>
          (getDeliveryRateCents(first) ?? Number.MAX_SAFE_INTEGER) -
          (getDeliveryRateCents(second) ?? Number.MAX_SAFE_INTEGER)
      )
      .slice(0, 3);
    const selectedRate = sortedRates[0];

    const selectedRateCents = getDeliveryRateCents(selectedRate);
    const merchandiseTotal = Number(
      cart.items_subtotal_price ?? cart.total_price
    );

    if (selectedRateCents === null) {
      throw new Error(
        fulfillmentText(
          "invalidRatePrice",
          "The delivery service returned an invalid price."
        )
      );
    }

    if (
      !Number.isFinite(merchandiseTotal) ||
      selectedRateCents >= merchandiseTotal / 2
    ) {
      throw new Error(
        fulfillmentText("contactUs", "Please contact us for delivery assistance.")
      );
    }

    const updatedCart = await saveDeliveryEstimate(postalCode, selectedRate);

    renderDeliveryAvailability(panel);
    const contact = panel.querySelector("[data-delivery-contact]");
    if (contact) {
      contact.hidden = true;
    }
    panel.dataset.rateValid = "true";
    status.textContent = "";
    updateCheckoutAvailability(updatedCart);
  } catch (error) {
    console.error("Unable to calculate the Freightcom delivery rate", error);
    invalidateDeliveryRate(
      fulfillmentText("contactUs", "Please contact us for delivery assistance.")
    );
    showDeliveryContact(panel);
  } finally {
    panel.removeAttribute("aria-busy");
    button.textContent = originalButtonText;
    updateDeliveryRateVisibility();
  }
}

async function loadCartPickupLocations(container) {
  const status = container.querySelector("[data-pickup-location-status]");
  const list = container.querySelector("[data-pickup-location-list]");
  const dataElement = container.querySelector("[data-pickup-variant-ids]");

  if (!status || !list || !dataElement) {
    return;
  }

  container.dataset.loading = "true";
  status.hidden = false;
  status.textContent = fulfillmentText(
    "loadingPickupLocations",
    "Loading pickup locations..."
  );
  list.replaceChildren();

  try {
    const variantIds = [...new Set(JSON.parse(dataElement.textContent))];
    const locationMaps = await Promise.all(
      variantIds.map((variantId) => getVariantPickupLocations(variantId))
    );
    const commonLocations = locationMaps.length
      ? [...locationMaps[0].entries()].filter(([locationId]) =>
          locationMaps.every((locations) => locations.has(locationId))
        )
      : [];

    if (!commonLocations.length) {
      status.textContent = fulfillmentText(
        "noCommonPickupLocation",
        "No single pickup location is currently available for every item in this order."
      );
      return;
    }

    const cart = await getCart();
    const savedLocationId = cart.attributes?.[PICKUP_LOCATION_ID_ATTRIBUTE];
    const selectedEntry =
      commonLocations.find(([locationId]) => locationId === savedLocationId) ||
      commonLocations[0];

    commonLocations.forEach(([locationId, location]) => {
      const option = document.createElement("label");
      const radio = document.createElement("input");
      const card = document.createElement("span");
      const title = document.createElement("h3");
      const time = document.createElement("p");
      const address = document.createElement("address");

      option.className = "cart-pickup-location-option";
      radio.type = "radio";
      radio.name = "cart-pickup-location";
      radio.value = locationId;
      radio.checked = locationId === selectedEntry[0];
      radio.dataset.locationName = location.name;
      radio.dataset.locationAddress = location.addressText;
      card.className = "cart-pickup-location";
      title.textContent = location.name;
      time.className = "cart-pickup-location-time";
      time.textContent = location.time;
      address.innerHTML = location.addressHtml;
      card.append(title, time, address);
      option.append(radio, card);
      list.append(option);
    });

    status.hidden = true;
    container.dataset.loaded = "true";
    container.dataset.selectedLocationId = selectedEntry[0];
    const selectedCart =
      savedLocationId !== selectedEntry[0]
        ? await savePickupLocation(selectedEntry[1])
        : cart;
    updateCheckoutAvailability(selectedCart);
  } catch (error) {
    status.textContent = error.message;
  } finally {
    delete container.dataset.loading;
  }
}

function updatePickupLocationsVisibility() {
  const selector = document.querySelector("[data-cart-selector]");
  const container = document.querySelector("[data-cart-pickup-locations]");

  if (!selector || !container) {
    return;
  }

  const showLocations = selector.dataset.currentValue === "Pickup";
  container.hidden = !showLocations;

  if (
    showLocations &&
    container.dataset.loaded !== "true" &&
    container.dataset.loading !== "true"
  ) {
    loadCartPickupLocations(container);
  }
}

class CartFulfillmentSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (event) => this.onChange(event));
  }

  async onChange(event) {
    const input = event.target.closest('input[type="radio"]');

    if (!input || !FULFILLMENT_VALUES.includes(input.value)) {
      return;
    }

    const inputs = this.querySelectorAll('input[type="radio"]');
    const errorElement = this.querySelector(".cart-fulfillment-error");

    inputs.forEach((radio) => {
      radio.disabled = true;
    });
    this.classList.add("is-loading");
    errorElement.hidden = true;
    setCartError("");

    try {
      const cart = await getCart();
      const cartItems = document.querySelector("cart-items");
      const sections = cartItems
        ? cartItems.getSectionsToRender().map((section) => section.section)
        : [];

      let parsedState = cart;
      let updatesRemaining = cart.items.length + 1;

      while (updatesRemaining > 0) {
        let lineIndex = -1;

        for (let index = parsedState.items.length - 1; index >= 0; index -= 1) {
          if (getFulfillmentMethod(parsedState.items[index]) !== input.value) {
            lineIndex = index;
            break;
          }
        }

        if (lineIndex < 0) {
          break;
        }

        const item = parsedState.items[lineIndex];
        const body = JSON.stringify({
          line: lineIndex + 1,
          quantity: item.quantity,
          properties: {
            ...(item.properties || {}),
            [FULFILLMENT_PROPERTY]: input.value,
          },
          sections,
          sections_url: window.location.pathname,
        });
        const response = await fetch(routes.cart_change_url, {
          ...fetchConfig(),
          body,
        });
        parsedState = await response.json();

        if (!response.ok || parsedState.errors) {
          throw new Error(
            typeof parsedState.errors === "string"
              ? parsedState.errors
              : fulfillmentText(
                  "unableSaveSelection",
                  "Unable to save this selection. Please try again."
                )
          );
        }

        updatesRemaining -= 1;
      }

      if (updatesRemaining === 0) {
        throw new Error(
          fulfillmentText(
            "unableSyncSelection",
            "Unable to synchronize the fulfillment selection."
          )
        );
      }

      if (input.value === "Delivery") {
        parsedState = await savePickupLocation(null, sections);
        parsedState = await removePickupDiscount(parsedState, sections);
      } else {
        parsedState = await saveDeliveryEstimate(null, null);
        parsedState = await applyPickupDiscount(parsedState, sections);
      }
      refreshCartSections(parsedState);
      updateCheckoutAvailability(parsedState);
    } catch (error) {
      setCartError(error.message);

      try {
        await document.querySelector("cart-items")?.updateSectionContents();
        updateCheckoutAvailability(await getCart());
      } catch (_refreshError) {
        errorElement.textContent = error.message;
        errorElement.hidden = false;
        inputs.forEach((radio) => {
          radio.disabled = false;
        });
      }
    } finally {
      this.classList.remove("is-loading");
    }
  }
}

if (!customElements.get("cart-fulfillment-selector")) {
  customElements.define("cart-fulfillment-selector", CartFulfillmentSelector);
}

async function submitDeliveryContact(form) {
  if (form.dataset.submitting === "true") {
    return;
  }

  const panel = document.querySelector("[data-delivery-contact]");
  const button = document.querySelector(
    'button[form="DeliveryContactForm"][type="submit"]'
  );
  const feedback = panel?.querySelector("[data-delivery-contact-feedback]");

  if (!panel || !button) {
    return;
  }

  const originalText = button.textContent;
  form.dataset.submitting = "true";
  button.disabled = true;
  button.setAttribute("aria-busy", "true");
  button.textContent = fulfillmentText("contactSending", "Sending request...");

  if (feedback) {
    feedback.hidden = true;
    feedback.textContent = "";
  }

  try {
    const postalCode = document
      .querySelector("#Cart-delivery-postal-code")
      ?.value.trim()
      .toUpperCase();
    let cart = null;

    try {
      if (window.syncCartFormAnswersToLineProperties) {
        await window.syncCartFormAnswersToLineProperties();
      }
      cart = await getCart();
    } catch (cartError) {
      console.error("Unable to add the latest cart details to the request", cartError);
    }

    const body = form.querySelector('[name="contact[body]"]');
    if (body) {
      body.value = buildDeliveryContactBody(cart, postalCode);
    }

    const response = await fetch(form.action, {
      method: form.method || "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    const responseHtml = await response.text();
    const responseDocument = new DOMParser().parseFromString(
      responseHtml,
      "text/html"
    );
    const success = responseDocument.querySelector(
      ".cart-delivery-contact-success"
    );

    if (!response.ok || !success) {
      const responseError = responseDocument.querySelector(
        ".cart-delivery-contact-error"
      );
      throw new Error(
        responseError?.textContent.trim() ||
          fulfillmentText(
            "contactError",
            "We couldn't send your request. Please try again."
          )
      );
    }

    const heading = document.createElement("h3");
    const message = document.createElement("p");
    heading.textContent = fulfillmentText("contactSuccessHeading", "Thanks!");
    message.textContent = fulfillmentText(
      "contactSuccess",
      "We've received your delivery assistance request."
    );
    panel.classList.add("is-success");
    panel.setAttribute("role", "status");
    panel.setAttribute("aria-live", "polite");
    panel.replaceChildren(heading, message);
  } catch (error) {
    if (feedback) {
      feedback.textContent = error.message;
      feedback.hidden = false;
    }
  } finally {
    delete form.dataset.submitting;

    if (button.isConnected) {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.textContent = originalText;
    }
  }
}

document.addEventListener("click", (event) => {
  const rateButton = event.target.closest("[data-calculate-delivery-rate]");

  if (rateButton && !rateButton.disabled) {
    calculateDeliveryRates(rateButton.closest("[data-delivery-rate-panel]"));
  }
});

document.addEventListener("submit", (event) => {
  if (event.target.id !== "DeliveryContactForm") {
    return;
  }

  event.preventDefault();
  submitDeliveryContact(event.target);
});

document.addEventListener("input", (event) => {
  if (
    event.target.matches("#Cart-delivery-postal-code") ||
    event.target.matches("[data-heavy-delivery-form] input[type='text']")
  ) {
    invalidateDeliveryRate(
      fulfillmentText(
        "estimateAgain",
        "Check delivery availability again after completing your changes."
      )
    );
  }
});

document.addEventListener("change", (event) => {
  if (event.target.matches("[data-heavy-delivery-form] input[type='radio']")) {
    invalidateDeliveryRate(
      fulfillmentText(
        "estimateAgain",
        "Check delivery availability again after completing your changes."
      )
    );
  }
});

document.addEventListener("change", async (event) => {
  const input = event.target.closest('input[name="cart-pickup-location"]');

  if (!input) {
    return;
  }

  const container = input.closest("[data-cart-pickup-locations]");
  const location = {
    id: input.value,
    name:
      input.dataset.locationName ||
      fulfillmentText("pickupLocationFallback", "Pickup location"),
    addressText: input.dataset.locationAddress || "",
  };

  container?.setAttribute("aria-busy", "true");
  container
    ?.querySelectorAll('input[name="cart-pickup-location"]')
    .forEach((radio) => {
      radio.disabled = true;
    });
  const checkoutButton = document.querySelector("[data-cart-checkout]");

  if (checkoutButton) {
    checkoutButton.disabled = true;
  }
  setCartError("");

  try {
    const cart = await savePickupLocation(location);
    container.dataset.selectedLocationId = location.id;
    updateCheckoutAvailability(cart);
  } catch (error) {
    const previousInput = Array.from(
      container?.querySelectorAll('input[name="cart-pickup-location"]') || []
    ).find((radio) => radio.value === container?.dataset.selectedLocationId);

    if (previousInput) {
      previousInput.checked = true;
    }
    setCartError(error.message);

    try {
      updateCheckoutAvailability(await getCart());
    } catch (_cartError) {
      // Keep checkout disabled until the cart can be verified again.
    }
  } finally {
    container?.removeAttribute("aria-busy");
    container
      ?.querySelectorAll('input[name="cart-pickup-location"]')
      .forEach((radio) => {
        radio.disabled = false;
      });
  }
});

let pickupDiscountRefreshQueue = Promise.resolve();

async function refreshPickupDiscountAfterCartUpdate() {
  const cart = await getCart();
  const cartItems = document.querySelector("cart-items");
  const selector = document.querySelector("[data-cart-selector]");
  const sections = cartItems
    ? cartItems.getSectionsToRender().map((section) => section.section)
    : [];
  const pickupSelected =
    cart.items.length > 0 &&
    cart.items.every((item) => getFulfillmentMethod(item) === "Pickup") &&
    selector?.dataset.currentValue === "Pickup" &&
    selector.dataset.pickupDiscountAvailable === "true";
  const updatedCart = pickupSelected
    ? await applyPickupDiscount(cart, sections)
    : await removePickupDiscount(cart, sections);

  if (updatedCart.sections) {
    refreshCartSections(updatedCart);
  }
  updateCheckoutAvailability(updatedCart);
}

document.addEventListener("cart:updated", (event) => {
  if (event.detail?.cart) {
    updateCheckoutAvailability(event.detail.cart);
  }

  pickupDiscountRefreshQueue = pickupDiscountRefreshQueue
    .then(refreshPickupDiscountAfterCartUpdate)
    .catch((error) => {
      setCartError(error.message);
    });
});

mountDeliveryQuestionnaire();
updateDeliveryQuestionnaireVisibility();
updatePickupLocationsVisibility();

const initialCheckoutButton = document.querySelector("[data-cart-checkout]");

if (initialCheckoutButton) {
  getCart()
    .then(updateCheckoutAvailability)
    .catch((error) => setCartError(error.message));
}

// Items added elsewhere (such as product page upgrades) can leave the
// discount codes out of step with the selected fulfillment method
if (document.querySelector("[data-cart-selector]")) {
  pickupDiscountRefreshQueue = pickupDiscountRefreshQueue
    .then(refreshPickupDiscountAfterCartUpdate)
    .catch((error) => {
      setCartError(error.message);
    });
}
